import * as libphonenumber from "libphonenumber-js";

/**
 * Checks if the phoneNumber is valid phone number in the E.164 format
 */
export function isPhoneNumberE164(phoneNumber: string): boolean {
    const parsed = libphonenumber.parse(phoneNumber);

    return phoneNumber === libphonenumber.format(parsed, "E.164");
}

/**
 * country should be a two letter country code
 *
 * Returns null if the phoneNumber is invalid
 */
export function parsePhoneToE164(defaultCountry: libphonenumber.CountryCode, phoneNumber: string): string | null {
    const parsed = libphonenumber.parse(phoneNumber, { defaultCountry: defaultCountry });

    const formatted = libphonenumber.format(parsed, "E.164");

    if (formatted === "") {
        return null;
    }

    return formatted;
}

export function asYouType(defaultCountry: libphonenumber.CountryCode, input: string): string {
    const formatter = new libphonenumber.AsYouType(defaultCountry);
    return formatter.input(input);
}

/**
 * @param phonenumber must be a valid phone number in E.164 format. (Can
 * be checked with "isPhoneNumberE164")
 */
export function formatPhone(phoneNumber: string): string {
    const parsed = libphonenumber.parse(phoneNumber);
    return libphonenumber.format(parsed, "National");
}



// WEBPACK FOOTER //
// ./src/phone_number.ts